export const Staticbrands = [
    {
        "_id": "67c564ac910ac20b047b76cb",
        "title": "EKTA",
        "description": "EKTA 30%",
        "image": "",
        "createdAt": "2025-03-03T08:13:32.755Z",
        "updatedAt": "2025-03-03T08:13:32.755Z",
        "__v": 0
    },
    {
        "_id": "67c565a5910ac20b047b7920",
        "title": "SIMARR",
        "description": "SIMARR 50%",
        "image": "",
        "createdAt": "2025-03-03T08:17:41.487Z",
        "updatedAt": "2025-03-03T08:17:41.487Z",
        "__v": 0
    },
    {
        "_id": "67c565bb910ac20b047b792a",
        "title": "IMPORTED",
        "description": "IMPORTED",
        "image": "",
        "createdAt": "2025-03-03T08:18:03.369Z",
        "updatedAt": "2025-03-03T08:18:03.369Z",
        "__v": 0
    },
    {
        "_id": "67c58efc25680042a2ebf12c",
        "title": "PERPLEXUS",
        "description": "PERPLEXUS",
        "image": "",
        "createdAt": "2025-03-03T11:14:04.115Z",
        "updatedAt": "2025-03-03T11:14:04.115Z",
        "__v": 0
    },
    {
        "_id": "67c5aa9b25680042a2ec0685",
        "title": "BUDDYZ",
        "description": "BUDDYZ",
        "image": "",
        "createdAt": "2025-03-03T13:11:55.628Z",
        "updatedAt": "2025-03-03T13:11:55.628Z",
        "__v": 0
    },
    {
        "_id": "67c5aaae25680042a2ec0689",
        "title": "FUNSKOOL",
        "description": "FUNSKOOL ",
        "image": "",
        "createdAt": "2025-03-03T13:12:14.903Z",
        "updatedAt": "2025-03-03T13:12:14.903Z",
        "__v": 0
    },
    {
        "_id": "67c5ab8c25680042a2ec078e",
        "title": "AWALS",
        "description": "AWALS ",
        "image": "",
        "createdAt": "2025-03-03T13:15:56.859Z",
        "updatedAt": "2025-03-03T13:15:56.859Z",
        "__v": 0
    },
    {
        "_id": "67c5ab9625680042a2ec0799",
        "title": "RATNA",
        "description": "RATNA ",
        "image": "",
        "createdAt": "2025-03-03T13:16:06.882Z",
        "updatedAt": "2025-03-03T13:16:06.882Z",
        "__v": 0
    },
    {
        "_id": "67c5abb325680042a2ec07a9",
        "title": "CHICCO",
        "description": "CHICCO",
        "image": "",
        "createdAt": "2025-03-03T13:16:35.515Z",
        "updatedAt": "2025-03-03T13:16:35.515Z",
        "__v": 0
    },
    {
        "_id": "67c5abc625680042a2ec07bb",
        "title": "GOOYO",
        "description": "GOOYO ",
        "image": "",
        "createdAt": "2025-03-03T13:16:54.704Z",
        "updatedAt": "2025-03-03T13:16:54.704Z",
        "__v": 0
    },
    {
        "_id": "67c6a98648a8bf8ef06c4cdc",
        "title": "UNIK PLAY",
        "description": "UNIL PLAY",
        "image": "",
        "createdAt": "2025-03-04T07:19:34.003Z",
        "updatedAt": "2025-03-04T07:19:34.003Z",
        "__v": 0
    },
    {
        "_id": "67c6b4b148a8bf8ef06c4f46",
        "title": "ROCK LIGHT",
        "description": "ROCKLIGHT RECHARGEABLE LAMPS ",
        "image": "",
        "createdAt": "2025-03-04T08:07:13.814Z",
        "updatedAt": "2025-03-04T08:07:13.814Z",
        "__v": 0
    },
    {
        "_id": "67c6c1d348a8bf8ef06c524e",
        "title": "MIRADA",
        "description": "MIRADA GIRLS ",
        "image": "",
        "createdAt": "2025-03-04T09:03:15.106Z",
        "updatedAt": "2025-03-04T09:03:15.106Z",
        "__v": 0
    },
    {
        "_id": "67c6d2e048a8bf8ef06c5a70",
        "title": "INTEX",
        "description": "INTEX",
        "image": "",
        "createdAt": "2025-03-04T10:16:00.532Z",
        "updatedAt": "2025-03-04T10:16:00.532Z",
        "__v": 0
    },
    {
        "_id": "67c6d96248a8bf8ef06c5b09",
        "title": "ZEPHYR",
        "description": "ZEPHYR",
        "image": "",
        "createdAt": "2025-03-04T10:43:46.188Z",
        "updatedAt": "2025-03-04T10:43:46.188Z",
        "__v": 0
    },
    {
        "_id": "67c6f27e48a8bf8ef06c62a3",
        "title": "FUN CLASSIC TOYS",
        "description": "FUN CLASSIC TOYS",
        "image": "",
        "createdAt": "2025-03-04T12:30:54.936Z",
        "updatedAt": "2025-03-04T12:30:54.936Z",
        "__v": 0
    },
    {
        "_id": "67c6f53b48a8bf8ef06c67e9",
        "title": "I TOYS",
        "description": "I TOYS",
        "image": "",
        "createdAt": "2025-03-04T12:42:35.832Z",
        "updatedAt": "2025-03-04T12:42:35.832Z",
        "__v": 0
    },
    {
        "_id": "67c710dd48a8bf8ef06c6bfb",
        "title": "MECHANIX",
        "description": "MECHANIX",
        "image": "",
        "createdAt": "2025-03-04T14:40:29.883Z",
        "updatedAt": "2025-03-04T14:40:29.883Z",
        "__v": 0
    },
    {
        "_id": "67c835cfe77d21085e9652e7",
        "title": "DOMS",
        "description": "DOMS",
        "image": "",
        "createdAt": "2025-03-05T11:30:23.461Z",
        "updatedAt": "2025-03-05T11:30:23.461Z",
        "__v": 0
    },
    {
        "_id": "67c86956e77d21085e9661a4",
        "title": "TOYS HUB",
        "description": "TOYS HUB",
        "image": "",
        "createdAt": "2025-03-05T15:10:14.912Z",
        "updatedAt": "2025-03-05T15:10:14.912Z",
        "__v": 0
    },
    {
        "_id": "67c964a55f21f1960804b715",
        "title": "CELLO",
        "description": "CELLO",
        "image": "",
        "createdAt": "2025-03-06T09:02:29.506Z",
        "updatedAt": "2025-03-06T09:02:29.506Z",
        "__v": 0
    },
    {
        "_id": "67c96a7f5f21f1960804bd16",
        "title": "DUBBLIN",
        "description": "DUBBLIN",
        "image": "",
        "createdAt": "2025-03-06T09:27:27.485Z",
        "updatedAt": "2025-03-06T09:27:27.485Z",
        "__v": 0
    },
    {
        "_id": "67c9925b5f21f1960804df5d",
        "title": "PROBOTT",
        "description": "PROBOTT",
        "image": "",
        "createdAt": "2025-03-06T12:17:31.156Z",
        "updatedAt": "2025-03-06T12:17:31.156Z",
        "__v": 0
    },
    {
        "_id": "67cbf7ff94d7ac94a7d3da9b",
        "title": "SMARTIVITY",
        "description": "SMARTIVITY",
        "image": "",
        "createdAt": "2025-03-08T07:55:43.610Z",
        "updatedAt": "2025-03-08T07:55:43.610Z",
        "__v": 0
    },
    {
        "_id": "67cc009794d7ac94a7d3db01",
        "title": "STEAM",
        "description": "STEAM",
        "image": "",
        "createdAt": "2025-03-08T08:32:23.867Z",
        "updatedAt": "2025-03-08T08:32:23.867Z",
        "__v": 0
    },
    {
        "_id": "67cc42caf754f6d45796f709",
        "title": "BANFA",
        "description": "BANFA",
        "image": "",
        "createdAt": "2025-03-08T13:14:50.163Z",
        "updatedAt": "2025-03-08T13:14:50.163Z",
        "__v": 0
    },
    {
        "_id": "67cd3caff754f6d4579704c7",
        "title": "STANLEY",
        "description": "STANLEY",
        "image": "",
        "createdAt": "2025-03-09T07:01:03.744Z",
        "updatedAt": "2025-03-09T07:01:03.744Z",
        "__v": 0
    },
    {
        "_id": "67ce84cef0e2830c69a30ed9",
        "title": "FABER- CASTELL",
        "description": "",
        "image": "",
        "createdAt": "2025-03-10T06:21:02.420Z",
        "updatedAt": "2025-03-10T06:21:02.420Z",
        "__v": 0
    },
    {
        "_id": "67d0084192a95334b24a9b5c",
        "title": "MATTEL",
        "description": "MATTEL",
        "image": "",
        "createdAt": "2025-03-11T09:54:09.025Z",
        "updatedAt": "2025-03-11T09:54:09.025Z",
        "__v": 0
    }
]